// extracted by mini-css-extract-plugin
export var categoryTag = "ListOfArticles-module--categoryTag--a357c";
export var container = "ListOfArticles-module--container--37f79";
export var image = "ListOfArticles-module--image--39905";
export var section = "ListOfArticles-module--section--03e91";
export var title = "ListOfArticles-module--title--78ad5";
export var topText = "ListOfArticles-module--topText--bd229";
export var wrapper = "ListOfArticles-module--wrapper--aac22";